import { render, staticRenderFns } from "./PqDetailsPage.vue?vue&type=template&id=84b00f86&scoped=true&"
import script from "./PqDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PqDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b00f86",
  null
  
)

export default component.exports